var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 53,
    viewBox: "0 0 241 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8986 21.0322L13.8351 18.7159L0 10.8291V31.2357L36.894 52.2674V31.8609L29.5154 27.6546L27.3965 26.4465L22.1364 23.4481L17.8986 21.0322Z",
    fill: "#463C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8991 0L0.548828 9.89088L13.5615 17.309L17.8991 19.7814V0Z",
    fill: "#00BEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3961 25.1957V14.9923L36.3454 9.89088L18.9951 0V20.4066L22.3554 22.3223L27.3961 25.1957Z",
    fill: "#00BEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8942 30.6105V10.8291L28.4932 15.6179V25.8214L30.1735 26.7791L36.8942 30.6105Z",
    fill: "#463C64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2424 14.9932C66.2886 14.9932 67.7435 15.094 68.9687 15.9005C70.3981 16.833 71.0873 18.4459 71.0873 19.9833C71.0873 20.9659 70.8317 22.4783 69.4281 23.6625C68.0753 24.7967 66.5186 24.9731 65.2676 24.9731H64.0938V31.8027H61.4902V14.9932H65.2424ZM64.0938 22.604H65.2676C67.5138 22.604 68.5858 21.5203 68.5858 19.9581C68.5858 19.0256 68.2029 17.3622 65.2424 17.3622H64.0938V22.604Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8135 14.9932V29.3832H96.816V31.8027H89.21V14.9932H91.8135Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.817 27.7455H117.543L115.68 31.8028H112.872L121.346 14.0107L129.411 31.8028H126.603L124.817 27.7455ZM123.771 25.3261L121.244 19.6306L118.615 25.3261H123.771Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.903 17.4126V31.8027H148.3V17.4126H144.395V14.9932H154.808V17.4126H150.903Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.12 17.4123H175.331V21.6715H181.916V24.091H175.331V29.3832H182.12V31.8027H172.728V14.9932H182.12V17.4123Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M209.048 27.7455H201.775L199.911 31.8028H197.104L205.577 14.0107L213.643 31.8028H210.835L209.048 27.7455ZM208.002 25.3261L205.475 19.6306L202.846 25.3261H208.002Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M230.132 14.9932V25.1243C230.132 26.0316 230.158 27.1405 230.668 28.0223C231.179 28.8792 232.327 29.7609 233.833 29.7609C235.339 29.7609 236.488 28.8788 236.998 28.0223C237.508 27.1402 237.534 26.0313 237.534 25.1243V14.9932H240.138V25.8044C240.138 27.1402 239.857 28.7531 238.555 30.1642C237.662 31.1219 236.156 32.13 233.834 32.13C231.511 32.13 230.005 31.1219 229.112 30.1642C227.81 28.7528 227.529 27.1402 227.529 25.8044V14.9932H230.132Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.828 39.4912V42.543C189.163 42.094 189.664 41.9473 190.119 41.9473C190.685 41.9473 191.195 42.1581 191.558 42.4972C191.956 42.8729 192.207 43.432 192.207 44.1105C192.207 44.7429 191.985 45.3294 191.558 45.751C191.195 46.1175 190.75 46.31 190.138 46.31C189.404 46.31 189.033 45.9709 188.829 45.6773V46.1725H187.492V39.4915H188.828V39.4912ZM189.042 43.3865C188.884 43.5515 188.745 43.7894 188.745 44.138C188.745 44.4767 188.893 44.7245 189.051 44.8708C189.265 45.0724 189.562 45.1736 189.812 45.1736C190.044 45.1736 190.304 45.0819 190.509 44.8895C190.704 44.7059 190.833 44.4404 190.833 44.138C190.833 43.8077 190.703 43.5423 190.509 43.3587C190.295 43.1574 190.063 43.0837 189.794 43.0837C189.506 43.0837 189.255 43.1662 189.042 43.3865Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.117 45.65L195.14 42.085H196.68L197.85 44.3028L198.991 42.085H200.495L197.163 48.2711H195.659L197.117 45.65Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.229 46.1723L210.223 40.0596H211.411L212.951 43.7162L214.492 40.0596H215.68L216.673 46.1723H215.244L214.752 42.5245L213.202 46.1723H212.7L211.15 42.5245L210.659 46.1723H209.229Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.883 40.0596V44.9806H224.804V46.1723H221.453V40.0596H222.883Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M231.152 40.0596V46.1723H229.723V40.0596H231.152Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.791 41.251V46.1723H237.362V41.251H236.016V40.0596H240.137V41.251H238.791Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.d14b5e4434834ddf66fe3f8be199120d.svg";
export { ForwardRef as ReactComponent };